import { render, staticRenderFns } from "./recallRetrieveReportInitAction.vue?vue&type=template&id=5b6878ea&scoped=true"
import script from "./recallRetrieveReportInitAction.vue?vue&type=script&lang=js"
export * from "./recallRetrieveReportInitAction.vue?vue&type=script&lang=js"
import style0 from "./recallRetrieveReportInitAction.vue?vue&type=style&index=0&id=5b6878ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6878ea",
  null
  
)

export default component.exports